$(document).ready(() => {
  initFloatingContact()
})

function initFloatingContact() {
  const element = document.querySelector(".floating-contact")

  if (!element) {
    return
  }

  const toggle = element.querySelector(".floating-contact__toggle")
  const close = element.querySelector(".floating-contact__close")
  const panel = element.querySelector(".floating-contact__panel")

  const updatePanelWidth = () => {
    element.style.setProperty("--fc-panel-width", `${panel.offsetWidth}px`)
  }

  updatePanelWidth()

  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(updatePanelWidth).observe(panel)
  } else {
    window.addEventListener("resize", updatePanelWidth)
  }

  const setOpen = (open) => {
    element.classList.toggle("floating-contact--open", open)
    toggle.setAttribute("aria-expanded", open ? "true" : "false")
  }

  const onClickOutside = (event) => {
    if (!element.contains(event.target)) {
      setOpen(false)
    }
  }

  toggle.addEventListener("click", (event) => {
    event.preventDefault()
    const willOpen = !element.classList.contains("floating-contact--open")
    setOpen(willOpen)

    if (willOpen) {
      setTimeout(() => document.addEventListener("click", onClickOutside))
    } else {
      document.removeEventListener("click", onClickOutside)
    }
  })

  close.addEventListener("click", (event) => {
    event.preventDefault()
    setOpen(false)
    document.removeEventListener("click", onClickOutside)
  })

  panel.addEventListener("click", (event) => {
    event.stopPropagation()
  })
}
